import React, { useEffect } from "react";
import { loadAdsTag } from "@/lib/adsTracking";
import { HcaHero } from "@/components/hca/HcaHero";
import { HcaFacts } from "@/components/hca/HcaFacts";
import { HcaCurriculum } from "@/components/hca/HcaCurriculum";
import { HcaCareers } from "@/components/hca/HcaCareers";
import { HcaTuition } from "@/components/hca/HcaTuition";
import { HcaAdmissions } from "@/components/hca/HcaAdmissions";
import { HcaFaq } from "@/components/hca/HcaFaq";
import { HcaFinalCta, HcaStickyBar } from "@/components/hca/HcaFinalCta";

export default function HealthCareAssistant() {
    useEffect(() => {
        document.title = "Health Care Assistant Diploma — Surrey, BC | Heritage Community College";
        loadAdsTag();
    }, []);

    return (
        <div className="bg-[#F9F8F6] pb-20 md:pb-0" data-testid="hca-landing-page">
            <HcaHero />
            <HcaFacts />
            <HcaCurriculum />
            <HcaCareers />
            <HcaTuition />
            <HcaAdmissions />
            <HcaFaq />
            <HcaFinalCta />
            <HcaStickyBar />
        </div>
    );
}
